import { QuestionResults } from "@/types/resources";

/**
 * Count the number of distinct respondents across a section's
 * question results.
 *
 * A single respondent can contribute many answers to one section:
 *   - rotated sections (`cells_per_respondent > 1`) → one answer per
 *     cell per scoring question (e.g. concept testing with two
 *     concepts per persona gives 2× answers per persona),
 *   - non-rotated sections with multiple questions → one answer per
 *     question per persona,
 *   - MaxDiff → one answer per task per persona.
 *
 * Summing per-cell sample sizes or counting raw answers therefore
 * massively overstates N. Deduplicating on `persona.id` across every
 * group and every question in the section gives the true respondent
 * count — i.e. the number of people whose answers shaped the report.
 */
export function countUniqueRespondents(
  data: QuestionResults[] | undefined
): number {
  const ids = new Set<string>();
  (data ?? []).forEach((r) => {
    (r.groups ?? []).forEach((g) => {
      (g.answers ?? []).forEach((a) => {
        if (a.persona?.id) {
          ids.add(a.persona.id);
        }
      });
    });
  });
  return ids.size;
}
